import { FormGroup, Help } from '@/components/Form'
import { TextInput } from '@/components/inputs/TextInput'
import styles from './SignupTextInput.module.css'

interface SignupTextInputProps {
  label: string
  value: string
  onChange: (value: string) => void
  error?: string
  placeholder?: string
  staticText?: string
  isDisabled?: boolean
}

export function SignupTextInput({
  label,
  value,
  onChange,
  error,
  placeholder,
  staticText,
  isDisabled,
}: SignupTextInputProps) {
  return (
    <FormGroup label={label}>
      <TextInput
        staticText={staticText}
        className={styles.input}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        status={error ? 'danger' : 'default'}
        isDisabled={isDisabled}
        placeholder={placeholder}
      />
      <Help error={error} />
    </FormGroup>
  )
}
